import { ToolJob } from './models/tool.models';
import { ToolchainJob } from './models/toolchain.models';

export type JobRunColor = 'success' | 'error' | 'warning';

export type JobRunStatusPresentation = {
  status: string;
  icon: string;
  color: JobRunColor;
};

export type JobRunPresentation = JobRunStatusPresentation & {
  title: string;
};

export function isFinishedJobStatus(status: string | undefined): boolean {
  return status === 'Done' || status === 'Error';
}

export function getJobRunPresentation(
  run: ToolJob | ToolchainJob,
  resourceName = ''
): JobRunPresentation {
  return { title: resourceName, ...getJobRunStatusPresentation(getRunStatus(run)) };
}

function getRunStatus(run: ToolJob | ToolchainJob): string {
  if (!('toolchainJobId' in run)) return run.status;

  const activeToolJob = run.toolJobs.find(toolJob => !isFinishedJobStatus(toolJob.status));
  return activeToolJob?.status ?? run.status;
}

export function getJobRunStatusPresentation(status: string): JobRunStatusPresentation {
  if (status === 'Done') return { status: 'Finished', icon: 'check_circle', color: 'success' };
  if (status === 'Error') return { status: 'Failed', icon: 'cancel', color: 'error' };
  if (status === 'Pending') return { status: 'Waiting', icon: 'schedule', color: 'warning' };
  if (status === 'Action required') {
    return { status: 'Action required', icon: 'play_circle', color: 'warning' };
  }
  return { status: 'Running', icon: 'play_circle', color: 'warning' };
}
